import React from "react";
import { Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { withSize } from "react-sizeme";
import { Document } from "../../../../docuclipper/DocuclipperTypes";
import { ReduxState } from "../../../../redux";
import {
  fetchPage,
  fetchThumbnails,
  thumbnailsDeleteAll,
} from "../../../../redux/reducers/TemplateField";
import { LoadingTrackedButton } from "../../../Docuclipper/TrackedButton";
import { Thumbnail as ThumbnailComp } from "../Thumbnail";

const ThumbnailWithSize = withSize()(ThumbnailComp);

// const THUMBNAIL_HEIGHT = 300;
const THUMBNAIL_COUNT = 5;

type Props = {};

export const Thumbnails: React.SFC<Props> = () => {
  // const height = window.innerHeight * 0.8;

  // const count = Math.ceil(height / THUMBNAIL_HEIGHT);
  const count = THUMBNAIL_COUNT;
  const { thumbnails, page } = useSelector(
    (state: ReduxState) => state.TemplateField
  );
  const { files } = useSelector((state: ReduxState) => state.Files);
  let document: Document | undefined;
  if (files.length > 0) {
    document = files[0].document;
  }
  const { loading, error, hasMore, thumbnails: thumbnails2 } = thumbnails;

  const dispatch = useDispatch();

  let documentId: null | number = null;
  if (document) {
    documentId = document.id;
  }
  React.useEffect(() => {
    if (documentId) {
      dispatch(thumbnailsDeleteAll());
      dispatch(fetchThumbnails({ count }));
    }
  }, [dispatch, count, documentId]);

  const loadMoreElem = (
    <>
      {hasMore && (
        <LoadingTrackedButton
          isLoading={loading}
          action="thumbnailsLoadMoreClick"
          className="btn--load-more"
          variant="link"
          onClick={() => dispatch(fetchThumbnails({ count }))}
        >
          Load more
        </LoadingTrackedButton>
      )}
    </>
  );

  if (error) {
    return <Alert variant="danger">Error loading thumbnails</Alert>;
  }
  return (
    <div
      style={{
        height: window.innerHeight * 0.8,
        maxHeight: window.innerHeight * 0.8,
        overflowY: "scroll",
      }}
    >
      {thumbnails2.map((t, i) => (
        <ThumbnailWithSize
          selected={
            page.page
              ? i === parseInt(page.page.pageNumber.toString(), 10)
              : false
          }
          key={i}
          width={t.width}
          height={t.height}
          imageSrc={t.imageSrc}
          onClick={() => {
            dispatch(fetchPage({ pageNumber: i }));
          }}
        />
      ))}
      {loadMoreElem}
    </div>
  );
};
